import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/travis/build/Giphy/devportal-js/src/components/common/layout/landing.tsx";
import LandingPage from '@/views/landing';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <LandingPage mdxType="LandingPage" />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      